import { MODALS, openGlobalModal } from '~publish/hooks/useOpenGlobalModal'

type ReAuthChannel = { id: string; type: string }

/**
 * Opens app-shell's Instagram to Facebook re-auth flow, which walks the actor
 * through linking an Instagram account to a Facebook Page.
 */
export const openInstagramFacebookReAuthModal = (
  channel: ReAuthChannel,
): void => {
  openGlobalModal(MODALS.instagramFacebookReAuth, {
    channelId: channel.id,
    channelType: channel.type,
  })
}
